import { http } from '@/utils/request';

/** 首页聚合接口「我的卡」信息（my_card 非空时） */
export interface HomeMyCard {
    id: number; // 用户卡ID
    card_no: string; // 卡号
    balance: string; // 卡内余额
    apply_name: string; // 持卡人姓名
    apply_phone: string; // 手机号（账号）
    apply_id_card: string; // 身份证号
    pid: number;
    contact_name: string; // 收件人姓名
    contact_phone: string; // 收件电话
    contact_address: string; // 收件地址
    /** 状态：1待审核，2审核成功制卡中，3提交资料待制卡，4制卡成功待邮寄，5邮寄中，6邮寄完成，-1拒绝 */
    status: number;
    daily_limit: string; // 日限额
    annual_limit: string; // 年限额
    validity_date: string; // 有效期
    activation_amount: string; // 激活费
    make_amount: string; // 制卡费
    postage: string; // 邮寄费
    /** 激活费支付状态：1待支付，2支付成功 */
    pay_activation: number;
    /** 制卡费支付状态：1待支付，2支付成功 */
    pay_make: number;
    /** 邮寄费支付状态：1待支付，2支付成功 */
    pay_postage: number;
    email: string;
    idcard_img0: string;
    idcard_img1: string;
    idcard_img2: string;
    /** 开卡状态：1待开卡，2已开卡 */
    open_status: number;
    card_name: string; // 卡名
    card_pic: string; // 卡图
}

/** GET /api/Base/index — 首页聚合 */
export interface HomeIndexData {
    video: string; // 首页视频
    equity: number; // 我的股权数量（股）
    fund: number; // 我的基金数量（份）
    balance_ysm: string; // 我的资产余额（元）
    card_balance: number; // 卡内余额（元）
    /** 我的卡信息，为空字符串表示无卡 */
    my_card: '' | HomeMyCard,
    equity_value: number; // 持股市值（按各种股权计算来的）

fund_value: number; // 基金市值
}

/** GET /api/Base/index_pop — 首页弹窗单项 */
export interface HomeIndexPopItem {
    id: number;
    title: string; // 标题
    thumbnail: string;
    video: string;
    content: string; // HTML格式的详细内容
}

/** 客服信息（股权/基金/site_info 共用） */
export interface BaseKefuItem {
    id: number;
    name: string; // 名称
    img: string; // 头像
    type_name: string; // 客服类型，文字展示用
    times: string; // 工作时间
    url: string; // 客服链接
}

/** GET /api/Base/my_equity — 股权 */
export interface BaseMyEquityData {
    date: string; // 价格更新时间
    price: string; // 股权价格
    equity: number; // 持有股权数量（股）
    equity_lock: number; // 冻结股权数量（股）
    value: number; // 持有股权价值（元）
    kefu: BaseKefuItem[];
}

/** POST /api/Login/register */
export interface RegisterData {
    username: string; // 用户名/手机号
    password: string; // 登录密码
    password2: string; // 重复登录密码
    img_code: string; // 图形验证码
    invite_code: string; // 邀请码
    /** 可选：站点开启注册提现密码时由页面附带 */
    paypass?: string;
    paypass3?: string;
}

/** POST /api/Login/login */
export interface LoginData {
    username: string; // 用户名/手机号
    password: string; // 登录密码
    img_code: string; // 图形验证码
}
/**
 * 用户注册
 */
export function userregister(data: RegisterData) {
    return http<any>({
        method: 'POST',
        url: 'Login/register',
        data,
        header: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
}
/**
 * 用户登录
 */
export function login(data: LoginData) {
    return http<any>({
        method: 'POST',
        url: 'Login/login',
        data,
        header: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
}
/** GET /api/Base/my_fund — 基金 */
export interface BaseMyFundData {
    date: string; // 价格更新时间
    price: string; // 基金价格
    fund: number; // 持有基金数量（份）
    fund_lock: number; // 冻结基金数量（份）
    value: number; // 持有基金价值（元）
    kefu: BaseKefuItem[];
}

/** GET /api/Base/site_info — 邀请信息 */
export interface BaseInvitationInfo {
    direct_card_award: string; // 直推办卡现金奖励（元）
    direct_real_assets: string; // 直推办卡资产奖励（元）
    direct_real_equity: string; // 直推办卡股权奖励（股）
    direct_real_fund: string; // 直推办卡基金奖励（份）
    h5_host_url: string; // H5域名
    invite_code: string; // 邀请码
}

/** GET /api/Base/site_info — APP下载、邀请、客服、官方群聊 */
export interface BaseSiteInfoData {
    group_chat_qrcode: string; // 群聊二维码
    group_chat_name: string; // 群聊名称
    group_chat_subtit: string; // 群聊副标题
    group_chat_url: string; // 群聊地址
    down_app: string; // APP下载地址
    kefu: BaseKefuItem[];
    invitation_info: BaseInvitationInfo;
}

/**
 * 首页聚合（需登录）
 * GET /api/Base/index
 */
export function getHomeIndex() {
    return http<HomeIndexData>({
        method: 'GET',
        url: 'Base/index'
    });
}

/**
 * 首页弹窗（需登录）
 * GET /api/Base/index_pop
 */
export function getHomeIndexPop() {
    return http<HomeIndexPopItem[]>({
        method: 'GET',
        url: 'Base/index_pop'
    });
}

/**
 * 股权（需登录）
 * GET /api/Base/my_equity
 */
export function getBaseMyEquity() {
    return http<BaseMyEquityData>({
        method: 'GET',
        url: 'Base/my_equity'
    });
}

/**
 * 基金（需登录）
 * GET /api/Base/my_fund
 */
export function getBaseMyFund() {
    return http<BaseMyFundData>({
        method: 'GET',
        url: 'Base/my_fund'
    });
}

/**
 * APP下载、邀请信息、在线客服、官方群聊（需登录）
 * GET /api/Base/site_info
 */
export function getBaseSiteInfo() {
    return http<BaseSiteInfoData>({
        method: 'GET',
        url: 'Base/site_info'
    });
}

/** GET /api/Guquan/guquan_list — 单项 */
export interface GuquanListItem {
    id: number; // 股权ID
    q_name: string; // 股权名称
    q_pic: string; // 股权图
    price: string; // 现价
}

/** GET /api/Guquan/guquan_info — info 内股权信息 */
export interface GuquanInfoDetail {
    id: number;
    q_name: string; // 名称
    price: string; // 单价
}

/** GET /api/Guquan/guquan_info */
export interface GuquanInfoData {
    today: string; // 价格更新时间（实际就是今天）
    info: GuquanInfoDetail; // 股权信息
    balance_total: number; // 用户总可用余额
    option_num: number; // 持有股数（暂时没有冻结）
    price: string; // 单价
    kefu: BaseKefuItem[];
}

/**
 * 获取所有股权（需登录）
 * GET /api/Guquan/guquan_list
 */
export function getGuquanList() {
    return http<GuquanListItem[]>({
        method: 'GET',
        url: 'Guquan/guquan_list'
    });
}

/**
 * 持有股权详情（需登录）
 * GET /api/Guquan/guquan_info
 */
export function getGuquanInfo(id: number) {
    return http<GuquanInfoData>({
        method: 'GET',
        url: 'Guquan/guquan_info',
        data: { id }
    });
}

/** GET /api/Guquan/pros — 产品列表单项 */
export interface GuquanProListItem {
    id: number; // 产品ID（购买时使用）
    name: string; // 产品名称
    pic: string; // 产品图
    original_price: string; // 原价
    current_price: string; // 现价
    /** 结算方式：3永久分红 */
    rebate_type: number;
    daily_dividends: string; // 单份日分红
    equity_num: number; // 股权数量
    tags: string[]; // 标签
    progress: string; // 进度%
    /** 发售开始时间，空为不限 */
    release_start: string;
    /** 发售结束时间，空为不限 */
    release_end: string;
    /** 限购份数，0为不限 */
    purchase_limit: number;
    service_fee: number; // 服务费（元/份）
    q_name: string; // 股权名称
}

/** GET /api/Guquan/pro — info 内产品详情 */
export interface GuquanProDetail {
    id: number;
    name: string;
    pic: string;
    original_price: string;
    current_price: string;
    rebate_type: number;
    daily_dividends: string;
    q_id: number;
    period: number;
    status: number;
    equity_num: number;
    tags: string[];
    progress: string;
    release_start: number;
    release_end: number;
    del_flag: number;
    service_fee: number; // 服务费（元/份）
    px: number;
    /** 限购份数，0为不限 */
    purchase_limit: number;
    content: string; // HTML
    content2: string; // HTML
    q_name: string;
}

/** GET /api/Guquan/pro */
export interface GuquanProData {
    balance_total: number; // 可用余额（扣手续费用）
    balance_ysm: number; // 资产余额（购买股权用）
    info: GuquanProDetail;
}

/** POST /api/Guquan/buy */
export interface GuquanBuyData {
    id: number; // 产品ID
    num: number; // 购买份数
}

/** GET /api/Guquan/orders — 单项 */
export interface GuquanOrderRow {
    id: number;
    price: string; // 单价
    num: number; // 份数
    equity_num: number; // 股权数量
    money: string; // 订单总额
    ci_inc: string; // 日总分红
    /** 状态：1持仓中，2已出售 */
    status: number;
    create_time: string; // 持仓时间
    ok_num: number; // 已分红次数
    ok_inc: string; // 已分红金额
    total_inc: string;
    next_time: string; // 下次分红时间
    end_time: string;
    update_time: number;
    sell_time: string; // 出售时间
    q_name: string; // 股权名称
    pro_name: string; // 产品名称
}

/** GET /api/Guquan/orders */
export interface GuquanOrdersParams {
    page: number;
    per_page: number;
    /** 股权ID */
    q_id?: number;
    /** 0不限；1持仓中；2已出售 */
    status?: number;
    /** 产品ID */
    pid?: number;
}

/**
 * 股权产品列表（需登录）
 * GET /api/Guquan/pros
 */
export function getGuquanPros(q_id: number) {
    return http<GuquanProListItem[]>({
        method: 'GET',
        url: 'Guquan/pros',
        data: { q_id }
    });
}

/**
 * 股权产品详情（需登录）
 * GET /api/Guquan/pro
 */
export function getGuquanPro(id: number) {
    return http<GuquanProData>({
        method: 'GET',
        url: 'Guquan/pro',
        data: { id }
    });
}

/**
 * 购买股权产品（需登录）
 * POST /api/Guquan/buy
 */
export function postGuquanBuy(data: GuquanBuyData) {
    return http<any>({
        method: 'POST',
        url: 'Guquan/buy',
        data,
        header: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
}

/**
 * 股权订单列表（需登录）
 * GET /api/Guquan/orders
 */
export function getGuquanOrders(params: GuquanOrdersParams) {
    return http<FundsPageResult<GuquanOrderRow>>({
        method: 'GET',
        url: 'Guquan/orders',
        data: params
    });
}

/** 资产赎回申请详情（opening_cfg.order 有申请时） */
export interface DashiOpeningOrder {
    id: number;
    user_id: number;
    name: string; // 姓名
    /** 状态：1待审核，2通过，3拒绝 */
    status: number;
    /** 是否团队长：1是，2否 */
    is_leader: number;
    /** 参与年限；5 表示 5 年以上 */
    investment_time: number;
    mobile: string; // 手机号
    investment_pj: string[]; // 参与过的项目
    id_card: string; // 身份证号
    subsidy_amount: string; // 个人资产补贴金额
    create_time: string; // 申请/修改时间
    update_time: string; // 审核时间
    remark: string; // 拒绝原因
}

/** GET /api/Dashi/opening_cfg — 资产赎回【兑现】查看状态 */
export interface DashiOpeningCfgData {
    mobile: string; // 自己的手机号（账号）
    name: string; // 姓名
    id_card: string; // 身份证号
    back_assets_dz: string; // 团队长赎回可得个人资产（元）
    back_assets_dy: string; // 队员赎回可得个人资产（元）
    /** 是否可申请：9 可申请；0 未实名；1 申请待审核；2 已开网成功；3 未通过仅可修改 */
    do_status: number;
    /** 申请详情；无申请时为 "" */
    order: '' | DashiOpeningOrder;
}

/** POST /api/Dashi/opening_apply — 资产赎回申请/修改 */
export interface DashiOpeningApplyData {
    /** 是否团队长：1是，2否 */
    is_leader: 1 | 2;
    /** 投资项目，最多 3 项 */
    investment_pj: string[];
    /** 参与年限：仅可填 1、2、3、4、5（5 代表 5 年以上） */
    investment_time: 1 | 2 | 3 | 4 | 5;
}

/**
 * 资产赎回【兑现】查看状态（需登录）
 * GET /api/Dashi/opening_cfg
 */
export function getDashiOpeningCfg() {
    return http<DashiOpeningCfgData>({
        method: 'GET',
        url: 'Dashi/opening_cfg'
    });
}

/**
 * 资产赎回【兑现】申请/修改（需登录）
 * POST /api/Dashi/opening_apply
 */
export function postDashiOpeningApply(data: DashiOpeningApplyData) {
    return http<any>({
        method: 'POST',
        url: 'Dashi/opening_apply',
        data
    });
}

/** GET /api/Member/info — 个人基本信息 */
export interface MemberBasicInfo {
    id: number; // 用户ID
    username: string; // 账号/手机号
    balance: string; // 余额资产,买产品分红的
    balance_yj: string; // 佣金资产
    balance_rc: string; // 充值资产,只算充钱的
    balance_ysm: string; // 个人资产（云数贸）恢复资产那里送的
    balance_sy: string; // 收益钱包余额
    points: string; // 积分
    /** 实名状态：0未提交，1待审核，2通过，3拒绝 */
    auth_status: number;
    /** 邀请码状态：1允许邀请，0不能邀请 */
    invite_code_status: number;
    avatar: string; // 头像
    nickname: string; // 昵称
    c_total: number; // 抽奖剩余次数
    /** 是否设置过资金密码（字段名与后端一致） */
    is_payassword: number;//是否设置过支付密码
    real_name: string; // 真实姓名，未通过可为空
    invite_code: string; // 邀请码
}

/** GET /api/Member/realname — real_info（auth_status>0 时有） */
export interface MemberRealInfoDetail {
    real_name: string;
    id_card: string;
    /** auth_status=3 时有值，拒绝原因 */
    remark: string;
    verified: number; // 同 auth_status
    create_time: string; // 提交时间
    audit_time: string; // 审核时间
}

/** GET /api/Member/realname */
export interface MemberRealnameData {
    /** 状态：0未提交，1待审核，2通过，3拒绝 */
    auth_status: number;
    real_info?: MemberRealInfoDetail;
}

/** 绑定账户类型：1银行卡，2虚拟币，3支付宝，4微信 */
export type BankBindAccountType = 1 | 2 | 3 | 4;

/** USDT 链类型（后端约定） */
export type UsdtChainType = 'TRC20' | 'ERC20' | 'OMNI' | 'BEP20';

/** GET /api/Bank/list — 单项 */
export interface BankBindRow {
    id: number; // 数据ID
    type: BankBindAccountType;
    bank_name: string; // 银行名称 / 虚拟币种 / 支付宝姓名
    bank_account: string; // 卡号 / 虚拟币地址 / 支付宝账号
    bank_address: string; // 虚拟币链类型等；银行卡场景可为空
    /** 是否默认：1是，0否 */
    is_def: number;
    /** 持卡人姓名；虚拟币地址二维码；支付宝/微信收款码图等 */
    name: string;
}

/** POST /api/Bank/dobind */
export interface BankDobindData {
    type: BankBindAccountType;
    bank_name: string;
    name: string;
    bank_account: string;
    bank_address: string;
    /** 是否默认：0否，1是 */
    is_def: 0 | 1;
}

/** POST /api/Member/upavatar */
export interface MemberUpavatarData {
    avatar: string;
}

/** POST /api/Member/uppass */
export interface MemberUppassData {
    old: string;
    password: string;
    password2: string;
}

/** POST /api/Member/uppaypass */
export interface MemberUppaypassData {
    old?: string;
    password: string;
    password2: string;
}

/** POST /api/Member/do_real */
export interface MemberDoRealData {
    id_card: string;
    real_name: string;
}

/**
 * 获取个人基本信息（需登录）
 * GET /api/Member/info
 */
export function getMemberInfo() {
    return http<MemberBasicInfo>({
        method: 'GET',
        url: 'Member/info'
    });
}

/**
 * 修改头像（需登录）
 * POST /api/Member/upavatar
 */
export function postMemberUpavatar(data: MemberUpavatarData) {
    return http<any>({
        method: 'POST',
        url: 'Member/upavatar',
        data,
        header: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
}

/**
 * 修改登录密码（需登录）
 * POST /api/Member/uppass
 */
export function postMemberUppass(data: MemberUppassData) {
    return http<any>({
        method: 'POST',
        url: 'Member/uppass',
        data,
        header: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
}

/**
 * 设置/修改支付密码（需登录）
 * POST /api/Member/uppaypass
 */
export function postMemberUppaypass(data: MemberUppaypassData) {
    return http<any>({
        method: 'POST',
        url: 'Member/uppaypass',
        data,
        header: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
}

/**
 * 提交实名认证（需登录）
 * POST /api/Member/do_real
 */
export function postMemberDoReal(data: MemberDoRealData) {
    return http<any>({
        method: 'POST',
        url: 'Member/do_real',
        data,
        header: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
}

/**
 * 我的实名信息（需登录）
 * GET /api/Member/realname
 */
export function getMemberRealname() {
    return http<MemberRealnameData>({
        method: 'GET',
        url: 'Member/realname'
    });
}

/**
 * 我的银行卡（USDT）等绑定列表（需登录）
 * GET /api/Bank/list
 */
export function getBankBindList() {
    return http<BankBindRow[]>({
        method: 'GET',
        url: 'Bank/list'
    });
}

/**
 * 绑定银行卡/USDT/支付宝/微信（需登录）
 * POST /api/Bank/dobind
 */
export function postBankDobind(data: BankDobindData) {
    return http<any>({
        method: 'POST',
        url: 'Bank/dobind',
        data,
        header: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
}

/**
 * 设为默认收款方式（需登录）
 * POST /api/Bank/set_def
 */
export function postBankSetDef(id: number) {
    return http<any>({
        method: 'POST',
        url: 'Bank/set_def',
        data: { id },
        header: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
}

/**
 * 删除绑定（需登录）
 * POST /api/Bank/del
 */
export function postBankDel(id: number) {
    return http<any>({
        method: 'POST',
        url: 'Bank/del',
        data: { id },
        header: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
}

/** 分页列表（Funds 充值/提现/流水等共用结构） */
export interface FundsPageResult<T> {
    total: number;
    per_page: number;
    current_page: number;
    last_page: number;
    data: T[];
    has_more: boolean;
}

/** POST /api/Funds/do_recharge — 提交充值 */
export interface FundsDoRechargeData {
    /** 充值类型：1银行卡，3支付宝，4微信 */
    bank_type: 1 | 3 | 4;
    money: number;
    /** 充值凭证（不要加域名等按后端要求） */
    img: string;
}

/** GET /api/Funds/recharge — 充值记录单项 */
export interface FundsRechargeRow {
    money: string;
    /** 状态：1待审核，2通过，3拒绝 */
    status: number;
    order_no: string;
    create_time: string;
    audit_time: string;
    remark: string;
    /** 充值方式：1后台充值，2用户手动充值，3三方回调 */
    type: number;
    actual: string;
    hlv: string;
    /** 到账账户：balance 余额，balance_rc 充值余额 */
    balance_type: string;
    /** 充值类型：1银行卡，2USDT，3支付宝，4微信 */
    bank_type: number;
}

/** GET /api/Funds/recharge */
export interface FundsRechargeListParams {
    page: number;
    per_page: number;
    /** 0全部，1待审核，2通过，3拒绝 */
    status?: number;
}

/** POST /api/Funds/do_cash — 提现 */
export interface FundsDoCashData {
    bank_id: number;
    money: number;
    /** 提现账户：余额资产 balance，佣金资产 balance_yj */
    balance_type: 'balance' | 'balance_yj' | 'balance_ysm';
    /** 提款（安全）密码 */
    pay_password: string;
}

/** GET /api/Funds/cash — 提现记录单项 */
export interface FundsCashRow {
    order_no: string;
    /** 状态：1待审核，2通过，3拒绝 */
    status: number;
    money: string;
    arrival: string;
    fee: string;
    hlv: string;
    balance_type: string;
    arrival_pay: string;
    /** 提现卡类型：1银行卡，2虚拟币 */
    bank_type: number;
    bank_name: string;
    bank_account: string;
    /** 持卡人姓名 / 虚拟币链 */
    name: string;
    create_time: string;
    audit_time: string;
    remark: string | null;
    /** 存在时表示 T+1、T+3、T+7 等 */
    tday?: number;
}

/** GET /api/Funds/cash */
export interface FundsCashListParams {
    page: number;
    per_page: number;
    /** 0全部，1待审核，2提现成功，3提现失败 */
    status?: number;
    balance_type?: string;
    /** 与 end_time 须同时传 */
    start_time?: string;
    /** 与 start_time 须同时传，格式如 2024-12-22 23:59:59 */
    end_time?: string;
}

/** GET /api/Funds/list — 资金流水单项 */
export interface FundsLogRow {
    id: number;
    sn: string;
    /** 1增加，2减少（2 时前端金额前加负号） */
    acc_type: number;
    create_time: string;
    money: string;
    money_before: string;
    money_after: string;
    remark: string;
    balance_type: string;
    balance_type_name: string;
    type: number;
    type_name: string;
}

/** GET /api/Funds/list */
export interface FundsLogListParams {
    page: number;
    per_page: number;
    /** 账户类型，见 GET Index/fund_types */
    balance_type?: string;
    /** 类型 id，见 GET Index/fund_types */
    type?: number;
    start_time?: string;
    end_time?: string;
}

/** GET /api/Index/config — 系统配置（无需登录） */
export interface IndexConfigData {
    site_name: string;
    /** USDT 兑 RMB 汇率 */
    hlv: string;
    /** 注册开放：1 开放，0 禁止 */
    reg_open: string;
    def_avatar: string;
    /** 前端分享用域名 */
    h5_host_url: string;
    /** 在线支付成功后前端跳转路径 */
    h5_pay_success: string;
    down_app: string;
    app_logo: string;
    favicon: string;
    login_logo: string;
    index_video: string;
    /** 抽奖开关：1 开启，其它关闭 */
    chou_status: string;
    /** 每用户每天可抽奖次数 */
    chou_day: string;
    /** 实名通过赠送抽奖次数 */
    real_chou: string;
    zt_real_ren: string;
    zt_real_chou: string;
    online_rc_start: string;
    online_rc_end: string;
    rc_start: string;
    rc_end: string;
    recharge_sels: string[];
    cash_sels: string[];
    /** 周末是否允许提现 */
    cash_weekend: string;
    cash_start: string;
    cash_end: string;
    cash_min: string;
    /** 提现手续费（个人资产提现无手续费） */
    cash_fee: string;
    group_chat_url: string;
    group_chat_qrcode: string;
    balance_yj_cash_status: string;
    balance_cash_status: string;
    balance_xf: string;
    balance_yj_xf: string;
    balance_rc_xf: string;
    lottery_start: string;
    lottery_end: string;
    tz_start: string;
    tz_end: string;
    kefu_info: BaseKefuItem[];
    balance_yj_show: string;
    balance_rc_show: string;
    licai_show: string;
    /** 服务端时间戳（秒） */
    sys_time: number;
}

/**
 * 系统配置信息
 * GET /api/Index/config
 */
export function getIndexConfig() {
    return http<IndexConfigData>({
        method: 'GET',
        url: 'Index/config'
    });
}

/**
 * 资金账户类型、流水类型等（配合 Funds/list 筛选）
 * GET /api/Index/fund_types
 */
export function getIndexFundTypes() {
    return http<any>({
        method: 'GET',
        url: 'Index/fund_types'
    });
}

/**
 * 资金账户类型、流水类型等（配合 Funds/list 筛选）
 * GET /api/Index/fund_type_all
 */
/** GET /api/Index/fund_type_all */
export function getIndexFundTypeAll() {
    return http<any>({
        method: 'GET',
        url: 'Index/fund_type_all'
    });
}

/**
 * 提交充值（需登录）
 * POST /api/Funds/do_recharge
 */
export function postFundsDoRecharge(data: FundsDoRechargeData) {
    return http<any>({
        method: 'POST',
        url: 'Funds/do_recharge',
        data,
        header: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
}

/**
 * 充值记录（需登录）
 * GET /api/Funds/recharge
 */
export function getFundsRechargeList(params: FundsRechargeListParams) {
    return http<FundsPageResult<FundsRechargeRow>>({
        method: 'GET',
        url: 'Funds/recharge',
        data: params
    });
}

/**
 * 提现（需登录）
 * POST /api/Funds/do_cash
 */
export function postFundsDoCash(data: FundsDoCashData) {
    return http<any>({
        method: 'POST',
        url: 'Funds/do_cash',
        data,
        header: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
}

/**
 * 提现记录（需登录）
 * GET /api/Funds/cash
 */
export function getFundsCashList(params: FundsCashListParams) {
    return http<FundsPageResult<FundsCashRow>>({
        method: 'GET',
        url: 'Funds/cash',
        data: params
    });
}

/** POST /api/Funds/do_cash_sy — 收益钱包提现 */
export interface FundsDoCashSyData {
    bank_id: number; // 银行卡/虚拟币地址ID
    money: number; // 提现金额
    /** 提款（安全）密码 */
    pay_password: string;
}

/** GET /api/Funds/cash_sy — 提现记录单项（结构与 Funds/cash 一致） */
export type FundsCashSyRow = FundsCashRow;

/** GET /api/Funds/cash_sy */
export interface FundsCashSyListParams {
    page: number;
    per_page: number;
    /** 审核状态：0全部，1已提交，2待审核，3审核中，4通过，9拒绝 */
    status?: number;
    /** 出款状态：0全部，1待提交，2放款中，3放款成功，9放款失败 */
    pay_status?: number;
    /** 与 end_time 须同时传 */
    start_time?: string;
    /** 与 start_time 须同时传 */
    end_time?: string;
}

/**
 * 收益钱包提现（需登录）
 * POST /api/Funds/do_cash_sy
 */
export function postFundsDoCashSy(data: FundsDoCashSyData) {
    return http<any>({
        method: 'POST',
        url: 'Funds/do_cash_sy',
        data,
        header: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
}

/**
 * 收益钱包提现记录（需登录）
 * GET /api/Funds/cash_sy
 */
export function getFundsCashSyList(params: FundsCashSyListParams) {
    return http<FundsPageResult<FundsCashSyRow>>({
        method: 'GET',
        url: 'Funds/cash_sy',
        data: params
    });
}

/**
 * 资金记录明细（需登录）
 * GET /api/Funds/list
 */
export function getFundsLogList(params: FundsLogListParams) {
    return http<FundsPageResult<FundsLogRow>>({
        method: 'GET',
        url: 'Funds/list',
        data: params
    });
}

/** 签到日历单日（monthData 中非空字符串项） */
export interface SigninMonthDayItem {
    day: number;
    is_today: number;
    is_sign: number;
}

/** 日历格：空字符串表示占位 */
export type SigninMonthCell = '' | SigninMonthDayItem;

/** 签到满 X 天额外奖励 */
export interface SigninProAwardItem {
    day: number;
    balance: number;
    points: number;
    equity: number;
    fund: number;
    assets: number;
    physical: string;
}

/** GET /api/Signin/me — config */
export interface SigninMeConfig {
    daily_balance: number;
    daily_points: number;
    daily_equity: number;
    daily_fund: number;
    daily_assets: number;
    pro_award: SigninProAwardItem[];
}

/** GET /api/Signin/me — 签到基本信息 */
export interface SigninMeData {
    /** 日历起始星期：0周日，1周一 */
    week_start: number;
    /** 今日是否已签到：1已签，0未签 */
    today_sign: number;
    day_no: number;
    sys_time: number;
    is_recharge: number;
    /** 实名：2已实名，其它未实名 */
    auth_status: number;
    monthData: SigninMonthCell[];
    config: SigninMeConfig;
}

/** GET /api/Signin/sign_logs */
export interface SigninSignLogsParams {
    page: number;
    per_page: number;
    /** 4完成；1待领取，2已领取待发货，3已发货 */
    status?: number;
    /** 0不限，1包含实物，2不包含实物 */
    hasphysical?: number;
}

/** GET /api/Signin/sign_logs — 单项 */
export interface SigninSignLogRow {
    day_no: number;
    month_day: number;
    money: string;
    points: number;
    balance_ysm: string;
    equity: number;
    fund: number;
    physical: string;
    address: unknown | null;
    express: string;
    status: number;
    create_time: string;
    update_time: string;
}

/** POST /api/Signin/collection — 实物领取 */
export interface SigninCollectionData {
    /** 签到/抽奖记录 ID（以后端为准） */
    id: number;
    address_id: number;
}

/**
 * 签到基本信息（需登录）
 * GET /api/Signin/me
 */
export function getSigninMe() {
    return http<SigninMeData>({
        method: 'GET',
        url: 'Signin/me'
    });
}

/**
 * 签到（需登录）
 * POST /api/Signin/dosign
 */
export function postSigninDosign() {
    return http<any>({
        method: 'POST',
        url: 'Signin/dosign'
    });
}

/**
 * 签到历史（需登录）
 * GET /api/Signin/sign_logs
 */
export function getSigninSignLogs(params: SigninSignLogsParams) {
    return http<FundsPageResult<SigninSignLogRow>>({
        method: 'GET',
        url: 'Signin/sign_logs',
        data: params
    });
}

/**
 * 实物领取（需登录）
 * POST /api/Signin/collection
 */
export function postSigninCollection(data: SigninCollectionData) {
    return http<any>({
        method: 'POST',
        url: 'Signin/collection',
        data,
        header: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
}

/** GET /api/Team/info — 下级用户单项 */
export interface TeamSubUserRow {
    id: number;
    username: string; // 账号
    create_time: string; // 注册时间
    recharge_total: string; // 总充值
    cash_total: string; // 总提现
    /** 实名状态：0未提交，1待审核，2通过，3未通过 */
    auth_status: number;
    real_name: string | null;
    fan: number; // 总返佣
}

/** GET /api/Team/info — 我的团队 */
export interface TeamInfoData {
    invite_code: string;
    h5_host: string;
    down_app: string;
    balance_ysm: number; // 获得资产
    balance_yj: number; // 累计佣金
    sub1: TeamSubUserRow[];
    sub2: TeamSubUserRow[];
    sub3: TeamSubUserRow[];
    num1: number;
    num2: number;
    num3: number;
    num_total: number;
}

/**
 * 我的团队（需登录）
 * GET /api/Team/info
 */
export function getTeamInfo() {
    return http<TeamInfoData>({
        method: 'GET',
        url: 'Team/info'
    });
}

/** GET /api/Cards/international_card — user */
export interface InternationalCardUser {
    username: string;
    balance_ysm: string;
    auth_status: number;
    status: number;
    del_flag: number;
}

/** GET /api/Cards/international_card — card_pro */
export interface InternationalCardPro {
    id: number;
    name: string;
    pic: string;
    activation_amount: string;
    daily_limit: string;
    annual_limit: string;
    quantity: number;
    g_id: number;
    activation_discount: string;
    activation_zt: number;
    start_time: number;
    end_time: number;
    /** 进度 %；-1 不展示；0–100；100% 不可申请 */
    progress_rate: string;
}

/** GET /api/Cards/international_card */
export interface InternationalCardData {
    user: InternationalCardUser;
    /** 未申请该卡时为 "" */
    mycard: '' | HomeMyCard;
    card_pro: InternationalCardPro;
}

/** POST /api/Cards/apply — 申领国际卡（卡 ID + 收货地址） */
export interface InternationalCardApplyData {
    id: number;
    address_id: number;
}

/** GET /api/Address/list — 收货地址单项 */
export interface AddressRow {
    id: number;
    contact_name: string;
    contact_mobile: string;
    contact_address: string;
    /** 是否默认地址：1 是，0 否 */
    is_def: number;
}

/** POST /api/Address/add */
export interface AddressAddData {
    contact_name: string;
    contact_mobile: string;
    contact_address: string;
    is_def: number;
}

/** POST /api/Address/edit */
export interface AddressEditData {
    id: number;
    contact_name: string;
    contact_mobile: string;
    contact_address: string;
    is_def: number;
}

/**
 * 我的收货地址列表（需登录）
 * GET /api/Address/list
 */
export function getAddressList() {
    return http<AddressRow[]>({
        method: 'GET',
        url: 'Address/list'
    });
}

/**
 * 添加收货地址（需登录）
 * POST /api/Address/add
 */
export function postAddressAdd(data: AddressAddData) {
    return http<any>({
        method: 'POST',
        url: 'Address/add',
        data,
        header: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
}

/**
 * 修改收货地址（需登录）
 * POST /api/Address/edit
 */
export function postAddressEdit(data: AddressEditData) {
    return http<any>({
        method: 'POST',
        url: 'Address/edit',
        data,
        header: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
}

/**
 * 设置为默认地址（需登录）
 * POST /api/Address/def
 */
export function postAddressSetDef(id: number) {
    return http<any>({
        method: 'POST',
        url: 'Address/def',
        data: { id },
        header: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
}

/**
 * 删除收货地址（需登录）
 * POST /api/Address/del
 */
export function postAddressDel(id: number) {
    return http<any>({
        method: 'POST',
        url: 'Address/del',
        data: { id },
        header: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
}

/**
 * 收货地址详情（需登录）
 * GET /api/Address/info
 */
export function getAddressInfo(id: number) {
    return http<AddressRow>({
        method: 'GET',
        url: 'Address/info',
        data: { id }
    });
}

/** POST /api/Cards/pay — 支付步骤：54 激活费，55 制卡费，56 邮寄费 */
export type InternationalCardPayStep = 54 | 55 | 56;

/** POST /api/Cards/pay */
export interface InternationalCardPayData {
    id: number;
    step: InternationalCardPayStep;
}

/**
 * 国际专属卡信息（需登录）
 * GET /api/Cards/international_card
 */
export function getInternationalCard() {
    return http<InternationalCardData>({
        method: 'GET',
        url: 'Cards/international_card'
    });
}

/**
 * 申领国际卡（需登录）
 * POST /api/Cards/apply
 */
export function postInternationalCardApply(data: InternationalCardApplyData) {
    return http<any>({
        method: 'POST',
        url: 'Cards/apply',
        data,
        header: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
}

/**
 * 支付激活费/制卡费/邮寄费（需登录）
 * POST /api/Cards/pay
 */
export function postInternationalCardPay(data: InternationalCardPayData) {
    return http<any>({
        method: 'POST',
        url: 'Cards/pay',
        data,
        header: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
}
